import { connectFela } from '../../../dependencies';
import CreateMembershipForm from './CreateMembershipForm';
import * as styles from './CreateMembershipForm.styles';

export default connectFela(styles)(CreateMembershipForm);
